<template>
  <div>
    <CreateSubnet ref="CreateSubnet" v-on:createComplete="getNetworkData(network.page)"></CreateSubnet>
    <NetworkEdit ref="NetworkEdit" v-on:editComplete="networkEditComplete"></NetworkEdit>
    <Card shadow>
      <Row>
        <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getNetworkData()" style="float: left;"></AllTenantSwitch>
        <div style="float: left;">
          <Form ref="searchForm" inline @submit.native.prevent :model="searchForm" :label-width="60">
            <FormItem label="网络名称">
              <Input v-model="searchForm.name" style="min-width: 150px;" />
            </FormItem>
            <FormItem label="外部网络">
              <Select v-model="searchForm.router_external" style="min-width: 150px" placeholder="" clearable>
                <Option value="True">是</Option>
                <Option value="False">否</Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getNetworkData()">搜索</Button>
              <Button @click="searchFormReset" style="margin-left: 10px">重置</Button>
            </FormItem>
          </Form>
        </div>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getNetworkData(network.page)">刷新</Button>
          <Button
            @click="$refs.NetworkEdit.openModal()"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建网络</Button>
        </div>
      </Row>
      <Table
        :loading="tableLoading"
        ref="table"
        :data="network.data"
        :columns="network.columns">
        <template slot="more_action" slot-scope="props">
          <Button @click="$router.push({ name: 'network_detail', params: { id: props.row.id } })" type="primary" size="small" style="margin-right: 5px">详情</Button>
          <Dropdown transfer trigger="click" @on-click="v => {tableMoreActionTrigger(v, props.row)}">
            <Button type="dashed" size="small">
              更多操作
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="create_subnet">创建子网</DropdownItem>
              <DropdownItem name="edit">编辑</DropdownItem>
              <DropdownItem name="delete"><span :style="{color: 'red'}">删除</span></DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ network.data.length }} 条记录，总共 {{ network.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="network.count"
            :current="network.page"
            :page-size="network.size"
            @on-change="getNetworkData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudNetwork, deletePrivateCloudNetwork } from '@/api/private-cloud/network'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import CreateSubnet from './components/create-subnet'
import NetworkEdit from './components/network-edit'
import moment from 'moment'

export default {
  components: {
    CreateSubnet,
    NetworkEdit,
    AllTenantSwitch,
    moment
  },
  data () {
    return {
      tableLoading: false,
      network: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '租户',
            minWidth: 130,
            align: 'center',
            key: 'project_id',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row.project_id))
            }
          },
          {
            title: '网络名称',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'name'
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'ACTIVE' ? 'success'
                : status === 'BUILD' ? 'warning'
                  : status === 'DOWN' || status === 'ERROR' ? 'error'
                    : 'warning'
              let text = status === 'ACTIVE' ? '运行'
                : status === 'BUILD' ? '构建中'
                  : status === 'DOWN' ? 'Down'
                    : status === 'ERROR' ? '错误'
                      : '未知'
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          // {
          //   title: '已连接的子网',
          //   align: 'center',
          //   minWidth: 300,
          //   render: (h, params) => {
          //     const subnets = params.row.subnets
          //     let result = []
          //     for (let i in subnets) {
          //       result.push(h('p', subnets[i].name + ': ' + subnets[i].cidr))
          //     }
          //     return h('div', result)
          //   }
          // },
          {
            title: '共享的',
            align: 'center',
            minWidth: 100,
            key: 'shared',
            render: (h, params) => {
              let res = '是'
              if (!params.row.shared) {
                res = '否'
              }
              return h('span', res)
            }
          },
          {
            title: '外部网络',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let res = '是'
              let color = '#19be6b'
              if (!params.row['router:external']) {
                res = '否'
                color = '#2aa7ed'
              }
              return h('span', {
                style: {
                  color: color
                }
              }, res)
            }
          },
          {
            title: '活跃状态',
            align: 'center',
            minWidth: 100,
            key: 'admin_state_up',
            render: (h, params) => {
              let res = '是'
              if (!params.row.admin_state_up) {
                res = '否'
              }
              return h('span', res)
            }
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              return h('div', [
                h('div',
                  this.$refs.table.$scopedSlots.more_action({
                    row: params.row,
                    idx: params.row._index
                  })
                )
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      searchForm: {
        name: '',
        router_external: ''
      }
    }
  },
  mounted: function () {
    this.getNetworkData()
  },
  methods: {
    // 获取网络列表数据
    getNetworkData (value = 1) {
      this.network.page = value
      let params = {
        page: this.network.page,
        size: this.network.size,
        all_tenants: this.$refs.AllTenantSwitch.allTenants(),
        name: this.searchForm.name,
        'router:external': this.searchForm.router_external
      }
      this.tableLoading = true
      getPrivateCloudNetwork(params).then(res => {
        this.network.data = res.data.results
        this.network.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取网络列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取网络列表失败！服务器无响应'
          })
        }
      })
    },
    // 删除网络
    delete (row) {
      deletePrivateCloudNetwork(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getNetworkData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 表格更多操作触发
    tableMoreActionTrigger (name, row) {
      switch (name) {
        case 'create_subnet':
          this.$refs.CreateSubnet.openModal(row.id, row.name)
          break
        case 'edit':
          this.$refs.NetworkEdit.modifyOpenModal(row)
          break
        case 'delete':
          this.$Modal.confirm({
            title: '删除',
            content: '确定要删除网络「' + row.name + '」吗？ 此操作将无法撤回！',
            onOk: () => {
              this.delete(row)
            }
          })
          break
      }
    },
    // 网络编辑完成
    networkEditComplete (data = {}, isCreateSubnet = false) {
      this.getNetworkData(this.network.page)
      if (isCreateSubnet) {
        this.$refs.CreateSubnet.openModal(data.id, data.name)
      }
    },
    // 重置搜索表单
    searchFormReset () {
      this.searchForm = {
        name: '',
        router_external: ''
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
